import { PlayerStatChartConfigDto, BatterSessionReportChartConfigDto, ChartType } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

const BatterSessionTimelineChartSidebar = ({
  extraChartData,
  setTempLayout,
  tempLayout,
  chartNumber,
}: { chartNumber: 1 | 2 | 3 | 4 } & ChartConfigProps<PlayerStatChartConfigDto, BatterSessionReportChartConfigDto>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  const chartKey: keyof BatterSessionReportChartConfigDto = `batterSessionTimelineChartConfig_${chartNumber}`;
  const chartTitleKey: ChartType = `BatterSessionTimelineChart_${chartNumber}`;

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle(chartTitleKey as ChartType, extraChartData)}
      </Typography>
      <GenericRadioConfig
        label={t('View data as:')}
        options={extraChartData.availableStats}
        selected={extraChartData.playerStat}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            [chartKey]: {
              ...tempLayout[chartKey],
              playerStat: selected,
            },
          })
        }
        disabled={false}
      />
    </div>
  );
};

const BatterSessionTimelineChartSidebar_1 = (props: ChartConfigProps<PlayerStatChartConfigDto, BatterSessionReportChartConfigDto>) => {
  return <BatterSessionTimelineChartSidebar chartNumber={1} {...props} />;
};

const BatterSessionTimelineChartSidebar_2 = (props: ChartConfigProps<PlayerStatChartConfigDto, BatterSessionReportChartConfigDto>) => {
  return <BatterSessionTimelineChartSidebar chartNumber={2} {...props} />;
};

const BatterSessionTimelineChartSidebar_3 = (props: ChartConfigProps<PlayerStatChartConfigDto, BatterSessionReportChartConfigDto>) => {
  return <BatterSessionTimelineChartSidebar chartNumber={3} {...props} />;
};

const BatterSessionTimelineChartSidebar_4 = (props: ChartConfigProps<PlayerStatChartConfigDto, BatterSessionReportChartConfigDto>) => {
  return <BatterSessionTimelineChartSidebar chartNumber={4} {...props} />;
};

export {
  BatterSessionTimelineChartSidebar_1,
  BatterSessionTimelineChartSidebar_2,
  BatterSessionTimelineChartSidebar_3,
  BatterSessionTimelineChartSidebar_4,
};
